/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

import { PrexDecimal, PrexDecimalJsonValue, PrexDecimal_fromJsonValue, PrexDecimal_toJsonValue } from './prex.shared.primitives';
import { AccountId, AccountIdJsonValue, AccountId_fromJsonValue, AccountId_toJsonValue } from './prex.v2.r230522.id';

export interface Account {
  tradeMode: TradeMode;
  dailyNetDepositInUsdt: PrexDecimal;
  maxInitLeverageRestriction?: number;
  bonusReductionRatio: PrexDecimal;
  totalCopyingBalanceInUsdt: PrexDecimal;
}
export interface AccountJsonValue {
  tradeMode: TradeModeJsonValue;
  dailyNetDepositInUsdt: PrexDecimalJsonValue;
  maxInitLeverageRestriction?: number;
  bonusReductionRatio: PrexDecimalJsonValue;
  totalCopyingBalanceInUsdt: PrexDecimalJsonValue;
}
export function Account_fromJsonValue(json: AccountJsonValue): Account {
  return {
    tradeMode: TradeMode_fromJsonValue(json['tradeMode']),
    dailyNetDepositInUsdt: PrexDecimal_fromJsonValue(json['dailyNetDepositInUsdt']),
    maxInitLeverageRestriction: json['maxInitLeverageRestriction'] != null ? json['maxInitLeverageRestriction'] : undefined,
    bonusReductionRatio: PrexDecimal_fromJsonValue(json['bonusReductionRatio']),
    totalCopyingBalanceInUsdt: PrexDecimal_fromJsonValue(json['totalCopyingBalanceInUsdt']),
  };
}
export function Account_toJsonValue(value: Account): AccountJsonValue {
  return {
    'tradeMode': TradeMode_toJsonValue(value.tradeMode),
    'dailyNetDepositInUsdt': PrexDecimal_toJsonValue(value.dailyNetDepositInUsdt),
    'maxInitLeverageRestriction': value.maxInitLeverageRestriction != null ? value.maxInitLeverageRestriction : undefined,
    'bonusReductionRatio': PrexDecimal_toJsonValue(value.bonusReductionRatio),
    'totalCopyingBalanceInUsdt': PrexDecimal_toJsonValue(value.totalCopyingBalanceInUsdt),
  };
}

export interface AccountDelta {
  tradeMode?: TradeMode;
  dailyNetDepositInUsdt?: PrexDecimal;
  maxInitLeverageRestriction?: number;
  bonusReductionRatio?: PrexDecimal;
  totalCopyingBalanceInUsdt?: PrexDecimal;
}
export interface AccountDeltaJsonValue {
  tradeMode?: TradeModeJsonValue;
  dailyNetDepositInUsdt?: PrexDecimalJsonValue;
  maxInitLeverageRestriction?: number;
  bonusReductionRatio?: PrexDecimalJsonValue;
  totalCopyingBalanceInUsdt?: PrexDecimalJsonValue;
}
export function AccountDelta_fromJsonValue(json: AccountDeltaJsonValue): AccountDelta {
  return {
    tradeMode: json['tradeMode'] != null ? TradeMode_fromJsonValue(json['tradeMode']) : undefined,
    dailyNetDepositInUsdt: json['dailyNetDepositInUsdt'] != null ? PrexDecimal_fromJsonValue(json['dailyNetDepositInUsdt']) : undefined,
    maxInitLeverageRestriction: json['maxInitLeverageRestriction'] != null ? json['maxInitLeverageRestriction'] : undefined,
    bonusReductionRatio: json['bonusReductionRatio'] != null ? PrexDecimal_fromJsonValue(json['bonusReductionRatio']) : undefined,
    totalCopyingBalanceInUsdt: json['totalCopyingBalanceInUsdt'] != null ? PrexDecimal_fromJsonValue(json['totalCopyingBalanceInUsdt']) : undefined,
  };
}
export function AccountDelta_toJsonValue(value: AccountDelta): AccountDeltaJsonValue {
  return {
    'tradeMode': value.tradeMode != null ? TradeMode_toJsonValue(value.tradeMode) : undefined,
    'dailyNetDepositInUsdt': value.dailyNetDepositInUsdt != null ? PrexDecimal_toJsonValue(value.dailyNetDepositInUsdt) : undefined,
    'maxInitLeverageRestriction': value.maxInitLeverageRestriction != null ? value.maxInitLeverageRestriction : undefined,
    'bonusReductionRatio': value.bonusReductionRatio != null ? PrexDecimal_toJsonValue(value.bonusReductionRatio) : undefined,
    'totalCopyingBalanceInUsdt': value.totalCopyingBalanceInUsdt != null ? PrexDecimal_toJsonValue(value.totalCopyingBalanceInUsdt) : undefined,
  };
}

export interface AccountTableUpdates {
  s?: Record<AccountId, Account>;
  u?: Record<AccountId, AccountDelta>;
  i?: Record<AccountId, Account>;
  d?: Record<AccountId, unknown>;
}
export interface AccountTableUpdatesJsonValue {
  s?: Record<AccountId, AccountJsonValue>;
  u?: Record<AccountId, AccountDeltaJsonValue>;
  i?: Record<AccountId, AccountJsonValue>;
  d?: Record<AccountId, unknown>;
}
export function AccountTableUpdates_fromJsonValue(json: AccountTableUpdatesJsonValue): AccountTableUpdates {
  return {
    s: json['s'] != null ? Object.fromEntries(Object.entries(json['s']).map(([k, v]) => [k, Account_fromJsonValue(v)])) : undefined,
    u: json['u'] != null ? Object.fromEntries(Object.entries(json['u']).map(([k, v]) => [k, AccountDelta_fromJsonValue(v)])) : undefined,
    i: json['i'] != null ? Object.fromEntries(Object.entries(json['i']).map(([k, v]) => [k, Account_fromJsonValue(v)])) : undefined,
    d: json['d'] != null ? json['d'] : undefined,
  };
}
export function AccountTableUpdates_toJsonValue(value: AccountTableUpdates): AccountTableUpdatesJsonValue {
  return {
    's': value.s != null ? Object.fromEntries(Object.entries(value.s).map(([k, v]) => [k, Account_toJsonValue(v)])) : undefined,
    'u': value.u != null ? Object.fromEntries(Object.entries(value.u).map(([k, v]) => [k, AccountDelta_toJsonValue(v)])) : undefined,
    'i': value.i != null ? Object.fromEntries(Object.entries(value.i).map(([k, v]) => [k, Account_toJsonValue(v)])) : undefined,
    'd': value.d != null ? value.d : undefined,
  };
}

export type TradeMode =
  | 'MultiplePositions'
  | 'OneWay';
export type TradeModeJsonValue = TradeMode;
export const TradeMode_values: TradeMode[] = ['MultiplePositions', 'OneWay'];
export function TradeMode_fromJsonValue(json: TradeModeJsonValue): TradeMode {
  return json as TradeMode;
}
export function TradeMode_toJsonValue(value: TradeMode): TradeModeJsonValue {
  return value;
}
